import { ComponentProps, memo, SyntheticEvent, useCallback } from 'react'
import { useField } from 'react-final-form'
import { Radio } from '@cargomart/ui'
import { FieldValidator } from 'final-form'
import isEqual from 'lodash/isEqual'
import { checkFieldError } from 'shared/helpers/form'

interface IProps extends Omit<ComponentProps<typeof Radio>, 'onChange' | 'onFocus' | 'onBlur' | 'checked'> {
  name: string
  format?: (value: any, name: string) => string | number
  onPick?: (e: SyntheticEvent<HTMLInputElement>) => void
  parse?: (value: any, name: string) => string | number
  validate?: FieldValidator<string | number>
}

export const FieldRadio = memo<IProps>(function FieldRadio({ name, value, validate, parse, format, onPick, ...props }) {
  const { input, meta } = useField<string | number>(name, {
    type: 'radio',
    value,
    validate,
    format,
    parse,
    isEqual
  })

  const handleChange = useCallback(
    (event: SyntheticEvent<HTMLInputElement>) => {
      input.onChange(event)
      onPick?.(event)
    },
    [input, onPick]
  )

  return (
    <Radio
      {...props}
      checked={input.checked}
      invalid={(checkFieldError(meta) ? 'true' : 'false') as unknown as boolean}
      name={name}
      onBlur={input.onBlur}
      onChange={handleChange}
      onFocus={input.onFocus}
      value={input.value}
    />
  )
})
